type StringMapping = {
  [key: string]: string;
};

const mapping: StringMapping = {};
mapping['exam_description'] = 'exam_description';
mapping['procedure_type'] = 'procedure_type';
mapping['reason_for_visit'] = 'reason_for_visit';
mapping['notes'] = 'body';

export default mapping;
